import vFormInput from './FormInput';
import vFormSelect from './FormSelect';

export { vFormInput, vFormSelect };



// WEBPACK FOOTER //
// ./src/modules/sign/baseComponents/Form/index.js